import React, { useState } from "react";
import "./Login.scss";
import { Alert, Button, Col, Row, Typography } from "antd";
import { buildAuthUrl } from "../utils/urlConfig";
import { LOGIN_ERROR_KEY } from "../context/UserContext";

// Set by the backend login redirect (?loginError=...) or by UserContext when
// an existing session belongs to someone with no ongoing employment.
const readLoginError = (): string | null => {
  const fromUrl = new URLSearchParams(window.location.search).get(
    LOGIN_ERROR_KEY,
  );
  if (fromUrl) return fromUrl;
  try {
    return sessionStorage.getItem(LOGIN_ERROR_KEY);
  } catch {
    return null;
  }
};

const LoginPage: React.FC = () => {
  const loginUrl = buildAuthUrl("/oauth2/authorization/azure");
  const [loginError] = useState<string | null>(readLoginError);

  const handleLogin = () => {
    try {
      sessionStorage.removeItem(LOGIN_ERROR_KEY);
    } catch {
      // ignore - the message is only a convenience
    }
    window.location.assign(loginUrl);
  };

  return (
    <>
      <div className="login-container">
        <Row justify="center" align="middle" className="login-grid">
          <Col className="login-grid-column">
            <Typography.Title
              level={1}
              className="login-header"
              style={{ marginTop: 0 }}
            >
              <span className="logo-span"> Technology Reply</span>
              <br />
              HolidayApp
            </Typography.Title>
            {loginError === "account_inactive" && (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
                message="Your account is inactive"
                description="You don't have an ongoing employment, so you can't access HolidayApp. Please contact HR if you think this is a mistake."
              />
            )}
            <div className="login-cta-container">
              <div className="w-full">
                <Button
                  onClick={handleLogin}
                  className="login-cta"
                >
                  <span style={{ position: "relative", zIndex: 2 }}>
                    Login as a Replyer
                  </span>
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default LoginPage;
